import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference2: string }>;

export const DispatchcustomerReference2: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference2",
        customerReference2: props.parameter.customerReference2,
    });
};

export const chain = [DispatchcustomerReference2];

const setcustomerReference2 = createHandlerChainRunner(chain, "customerReference2");
export default setcustomerReference2;
